import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useRef } from "react";
import Agent from "../Network/Agent";

import RectifierCard from "../Component/Rms/home/RectifierCard";
import { RMS_ACTIVE_ALARM_FETCH_START } from "../Reducer/RmsActiveAlarmSlice";
import RectifierAlarmTd from "../CustomMemo/Rectifier/RectifierAlarmTd";
import { ACS_ACTIVE_ALARM_FETCH_START } from "../Reducer/AcsActiveAlarmSlice";
import { RECTIFIER_ALARM_FETCH_START } from "../Reducer/RectifierAlarmSlice";
import HomeGrid from "../CustomHook/HomeGrid";
import ReactEcharts from "echarts-for-react";
import { Link } from "react-router-dom";
import { cancelAllRequests, createController } from "../Network/API";
import LoadStatus from "../Component/Rms/home/LoadStatus";
import Availability from "../Component/Rms/home/Availability";
import Select from "react-select";

export default function HomeV5() {
    const [remainingTime, setRemainingTime] = useState(300);
    const echarts_react_2 = useRef();
    const echarts_react_3 = useRef();
    const dispatch = useDispatch();
    const [site_id, setSiteID] = useState();
    const [loading_export, setLoadingExport] = useState(false);
    const [switch_value_percent, setSwitchValuePercent] = useState('value');
    const controllerRef = useRef(null);
    const [tabActive, setTabActive] = useState('alarm');
    const [selectedCluster, setSelectedCluster] = useState(null);
    const form_data = {
        site_id: "",
        tenant_id: "",
        alarm_type: "",
        from_date: "",
        to_date: "",
        page: 1,
        export_type: 1,
        query: "",
        alarmIds: "",
    };


    const select_tenant_alarm_count = useSelector((state) => state.tenantAlarmCountReducer)

    // const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    // const fetchAll = async () => {


    //     const tasks = [
    //         await Agent.HOME.overview(dispatch),
    //         await delay(200),
    //         await Agent.HOME.TENANT_ALARM(dispatch),
    //         // await delay(100),
    //         //  await Agent.RMS_ALARM.rms_active_alarm(dispatch, form_data),
    //         // await delay(100),
    //         // await Agent.RMS_ALARM.acs_active_alarm(dispatch, form_data),
    //         //  await delay(100),
    //         //  await Agent.RMS_ALARM.rectifier_active_alarm(dispatch, form_data),
    //         // await delay(100),
    //         // await Agent.RMS_ALARM.rectifier_alarm_nav(dispatch),
    //         await delay(100),
    //         await Agent.RMS_ALARM.rectifier_alarm_count(dispatch),
    //         await delay(100),
    //         await Agent.RMS_ALARM.rectifier_count(dispatch),
    //     ];

    //     await Promise.allSettled(tasks); // They run in parallel and finish independently
    // };

    const delay = (ms) => new Promise(res => setTimeout(res, ms));

    const fetchAll = async (cluster_id = '') => {
        cancelAllRequests();

        const controller = createController();
        controllerRef.current = controller;
        const signal = controller.signal;

        const tasks = [
            Agent.HOME.overview(dispatch, signal, cluster_id),
            delay(50).then(() => Agent.HOME.TENANT_ALARM(dispatch, signal, cluster_id)),
            delay(100).then(() => Agent.RMS_ALARM.rectifier_alarm_count(dispatch, signal)),
            delay(200).then(() => Agent.RMS_ALARM.rectifier_count(dispatch, signal)),
        ];

        await Promise.allSettled(tasks);
    };

    const clusterSelector = useSelector((state) => state.clusterReducer);
    const clusterOptions = Array.isArray(clusterSelector?.data)
        ? clusterSelector.data.map((c) => ({ value: c.id, label: c.name }))
        : [];

    useEffect(() => {
        Agent.HOME.Cluster(dispatch);
    }, []);

    useEffect(() => {
        clearAlarm();
        const cid = selectedCluster?.value ?? '';
        fetchAll(cid);
        setRemainingTime(300);

        const fetchInterval = setInterval(() => {
            fetchAll(cid);
            setRemainingTime(300);
        }, 300000);

        const countdownInterval = setInterval(() => {
            setRemainingTime(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => {
            clearInterval(fetchInterval);
            clearInterval(countdownInterval);
            cancelAllRequests();
        };
    }, [selectedCluster]);


    // Format remaining time into mm:ss
    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    };


    const searchSite = (callback) => {

        form_data.site_id = callback;
        Agent.RMS_ALARM.rms_active_alarm(dispatch, form_data)
        Agent.RMS_ALARM.acs_active_alarm(dispatch, form_data)
        Agent.RMS_ALARM.rectifier_active_alarm(dispatch, form_data)
        setSiteID(callback)
    }


    const selector = useSelector((state) => state.homeReducer)
    const alarms = selector?.data


    const convertTime = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString()
    }

    const exportAlarm = async () => {
        setLoadingExport(true);
        try {
            const response = await Agent.RMS_ALARM.export_active_alarm(form_data);

            console.log(response)
            // Extract filename from Content-Disposition header or set a default
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'rms_active_alarms.xlsx';

            if (contentDisposition) {
                const matches = /filename[^;=\n]*=(['"]?)([^'";\n]*)\1/.exec(contentDisposition);
                if (matches && matches[2]) {
                    filename = matches[2];
                }
            }

            const blob = new Blob([response.data]);
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = filename;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadLink.href);
        } catch (error) {
            console.error('Error exporting file:', error);
        } finally {
            setLoadingExport(false);
        }
    }

    const exportAcsAlarm = async () => {
        setLoadingExport(true);
        try {

            form_data.export_type = 2;
            const response = await Agent.ACS_ALARM.export_active_alarm(form_data);

            console.log(response)
            // Extract filename from Content-Disposition header or set a default
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'acs_alarms.xlsx';

            if (contentDisposition) {
                const matches = /filename[^;=\n]*=(['"]?)([^'";\n]*)\1/.exec(contentDisposition);
                if (matches && matches[2]) {
                    filename = matches[2];
                }
            }

            const blob = new Blob([response.data]);
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = filename;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadLink.href);
        } catch (error) {
            console.error('Error exporting file:', error);
        } finally {
            setLoadingExport(false);
        }
    }

    const exportRectifierAlarm = async () => {
        setLoadingExport(true);
        try {
            const response = await Agent.RECTIFIER.export_active_alarm(form_data);

            console.log(response)
            // Extract filename from Content-Disposition header or set a default
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'rectifier_alarms.xlsx';

            if (contentDisposition) {
                const matches = /filename[^;=\n]*=(['"]?)([^'";\n]*)\1/.exec(contentDisposition);
                if (matches && matches[2]) {
                    filename = matches[2];
                }
            }

            const blob = new Blob([response.data]);
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = filename;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadLink.href);
        } catch (error) {
            console.error('Error exporting file:', error);
        } finally {
            setLoadingExport(false);
        }
    }

    const refreshAlarm = () => {
        dispatch(RMS_ACTIVE_ALARM_FETCH_START());
        dispatch(ACS_ACTIVE_ALARM_FETCH_START());
        dispatch(RECTIFIER_ALARM_FETCH_START());
        Agent.RMS_ALARM.rms_active_alarm(dispatch, form_data)
        Agent.RMS_ALARM.acs_active_alarm(dispatch, form_data)
        Agent.RMS_ALARM.rectifier_active_alarm(dispatch, form_data)
    }

    const clearAlarm = () => {
        dispatch(RMS_ACTIVE_ALARM_FETCH_START());
        dispatch(ACS_ACTIVE_ALARM_FETCH_START());
        dispatch(RECTIFIER_ALARM_FETCH_START());
        form_data.site_id = '';
        form_data.alarm_type = '';
        form_data.from_date = '';
        form_data.tenant_id = '';
        form_data.to_date = '';
        form_data.page = 1;
        // Agent.RMS_ALARM.rms_active_alarm(dispatch, form_data)
        // Agent.RMS_ALARM.acs_active_alarm(dispatch, form_data)
        // Agent.RMS_ALARM.rectifier_active_alarm(dispatch, form_data)
    }

    // tenant wise mains fail pie chart

    const tenantGradients = [
        ['#9B8CFF', '#5A4DFF'],
        ['#f96a74', '#fd3b48'],
        ['#33E6FF', '#1C9FFF'],
        ['#ffc61c', '#ffa91c'],
        ['#faa282', '#e16124'],
    ];
    const option = {

        // color need rgb color code, add liner gradient
        title: {
            text: 'Mains Fail',
            left: 'left',

            textStyle: {
                fontSize: 16,
                fontWeight: 'bold',
                color: '#333',

            },
        },

        tooltip: {
            trigger: 'item',
            formatter: function (params) {
                return `
            <b>${params.name}</b><br/>
            Value: ${params.value}<br/>
            (${params.percent ?? 0}%)
        `;
            }
        },


        legend: {
            orient: 'horizontal',
            bottom: 0,
            left: 'center',
            icon: 'circle',
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 16,
            textStyle: {
                color: '#333',
                fontSize: 12
            },
            data: !select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 ? select_tenant_alarm_count?.data?.map((tenant) => tenant.name) : []
        },
        series: [
            {
                name: 'Total Mains Fail',
                type: 'pie',
                selectedMode: 'single',
                radius: [0, 0],
                label: {
                    position: 'inner',
                    fontSize: 11,
                    color: '#0e0808',
                },
                labelLine: {
                    show: false
                },
                right: '0%',
                bottom: '20%',
                data: [{
                    value: !select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 ? select_tenant_alarm_count?.data?.reduce((sum, tenant) => sum + tenant.mains_fail, 0) : 0,
                    name: 'Total\n' + (!select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 ? select_tenant_alarm_count?.data?.reduce((sum, tenant) => sum + tenant.mains_fail, 0) : 0), // need break line here and show total value
                }]
            },
            {
                name: 'Mains Fail',
                type: 'pie',
                radius: ['40%', '70%'],
                top: '-20%',

                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: false,
                        fontSize: '15',
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: !select_tenant_alarm_count?.loading &&
                    select_tenant_alarm_count?.data?.length > 0
                    ? select_tenant_alarm_count.data.map((tenant, index) => {
                        const colors = tenantGradients[index % tenantGradients.length];

                        return {
                            value: tenant.mains_fail,
                            name: tenant.name,
                            itemStyle: {
                                color: {
                                    type: 'radial',   // pie chart → radial best
                                    x: 0.4,
                                    y: 0.4,
                                    r: 0.8,
                                    colorStops: [
                                        { offset: 0, color: colors[0] },
                                        { offset: 1, color: colors[1] }
                                    ]
                                }
                            }
                        };
                    })
                    : []
            }
        ]

    };

    // end pie chart

    // start new bar chart for dc low and site down

    const option_bar = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#000'
                }
            }
        },
        grid: {
            left: '4%',
            right: '4%',
            bottom: '3%',
            top: '5%',
            containLabel: true
        },
        legend: {
            data: ['DC Low', 'Site Down'],
            orient: 'horizontal',
            bottom: 0,
            left: 'center',
            icon: 'circle',
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 16,
            textStyle: {
                color: '#000',
                fontSize: 12
            },
        },
        xAxis: {
            type: 'category',
            data: !select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 ? select_tenant_alarm_count?.data?.map((tenant) => tenant.name) : [],
            axisLabel: {
                rotate: 45,
                fontSize: 10,
                color: '#000',
            },
        },
        yAxis: [{
            name: 'Count',
            nameLocation: 'middle',
            nameGap: 22,
            nameTextStyle: {
                fontWeight: 'bold',
                color: '#000'
            },
            type: 'value',
            axisLine: {
                lineStyle: {
                    color: '#000'
                }
            },
            splitLine: {
                lineStyle: {
                    color: '#ccc'
                }
            }
        }],
        series: [
            {
                name: 'DC Low',
                type: 'bar',
                data: !select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 ? select_tenant_alarm_count?.data?.map((tenant) => tenant.dc_low) : [],
                itemStyle: {
                    color: '#ff7f50'
                }
            },
            {
                name: 'Site Down',
                type: 'bar',
                data: !select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 ? select_tenant_alarm_count?.data?.map((tenant) => tenant.site_down) : [],
                itemStyle: {
                    color: '#87cefa'
                }
            }
        ]

    };

    return (
        <>

            <div className="container-fluid mt-2">

                <div className="row d-none">
                    <div className="col-12 mt-1 d-flex justify-content-between align-items-center">
                        <div className="page-title-box d-none">
                            <h4 className="page-title">Dashboard (RMS &amp; Access Control)</h4>
                            <p className="p-0 m-0"><span className="ms-3">Last update: <em className="text-danger">{convertTime(selector?.lastFetched)}</em></span> | Next refresh in: <b>{formatTime(remainingTime)}</b></p>
                        </div>
                        <div></div>
                        <div className="">
                            <ul className="nav nav-pills custom-nav-pills" id="pills-tab" role="tablist">
                                <li className="nav-item me-2" role="presentation">
                                    <Link className="nav-link nav-link-custom active" id="pills-noc-tab" data-bs-toggle="pill" data-bs-target="#pills-noc" type="button" role="tab" aria-controls="pills-home" aria-selected="true">NOC Dashboard</Link>
                                </li>
                                {/* <li className="nav-item me-2" role="presentation">
                                <button className="nav-link nav-link-custom" id="pills-management-tab" data-bs-toggle="pill" data-bs-target="#pills-management" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Management Dashboard</button>
                            </li> */}
                                <li className="nav-item me-2" role="presentation">
                                    <Link to={`/functional_dashboard`} className="nav-link nav-link-custom" role="tab" aria-controls="pills-contact" aria-selected="false">Functional Dashboard</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane fade show active" id="pills-noc" role="tabpanel" aria-labelledby="pills-noc-tab">
                        <div className="row g-2 mt-1 mb-2 ">
                            <HomeGrid title={`Total Site`} value={alarms?.total_sites} route={'#'} color={`bg-dark text-white`} icon={`fa-solid fa-map`} class={`shadow-dark`} valueColor={'text-dark'} />
                            {/* <HomeGrid title={`Total Lock`} value={alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.total_site : 0} route={`/sites`} color={`bg-info text-white`} icon={`fa-solid fa-lock`} class={`shadow-info`} valueColor={'text-info'} /> */}
                            <HomeGrid title={`Total Online`} value={alarms?.online_device} route={'/online_sites'} color={`bg-green`} icon={`fa-regular fa-signal`} class={`shadow-green`} valueColor={'text-success'} />
                            <HomeGrid
                                title={`Total Offline`}
                                value={alarms?.offline_device}
                                route={'/offline_sites'}
                                color={`bg-secondary text-white`}
                                icon={`fa-duotone fa-signal-slash`}
                                class={`shadow-black`}
                                valueColor={'text-gray'}
                                dropdown={{
                                    icon: 'fa-regular fa-door-closed',
                                    items: [
                                        { label: 'All Hours', count: alarms?.offline_device, route: '/offline_sites' },
                                        { label: '24 Hours', count: alarms?.offline_twenty_four, route: '/offline_sites/24' },
                                        { label: '48 Hours', count: alarms?.offline_fourteen_eight, route: '/offline_sites/48' },
                                        { label: '72 Hours', count: alarms?.offline_seventy_two, route: '/offline_sites/72' },
                                    ],
                                }}
                            />
                            <HomeGrid title={`Mains Fail`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.mains_fail : 0} route={'rms_alarm_filter/1/fatch'} color={`bg-danger text-white`} icon={`fa-regular fa-transformer-bolt `} class={`shadow-red`} />
                            <HomeGrid title={`DC Low`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.dc_low : 0} route={'rms_alarm_filter/2/fatch'} color={`bg-sapphire text-white`} icon={`fa-light fa-battery-quarter`} class={`shadow-sapphire`} />
                            {/* <HomeGrid title={`Overload`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.overloaded : 0} route={'rms_alarm_filter/25/fatch'} color={`bg-warning text-white`} icon={`fa-regular fa-chart-line-up`} class={`shadow-orange`} valueColor={'text-warning'} /> */}

                            <HomeGrid title={`No Load`} value={alarms?.no_load_sites??0} route={'/dc_energy'} color={`bg-warning  text-dark`} icon={`fa-regular fa-chart-line-down`} class={`shadow-purple`} valueColor={'text-warning'} />
                            <HomeGrid title={`Site Down`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.load_disconnect : 0} route={'rms_alarm_filter/26/fatch'} color={`bg-red text-white`} icon={`fa-regular fa-chart-line-down`} class={`shadow-purple`} valueColor={'text-danger'} />

                            <HomeGrid title={`Door Open`} value={alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.door_status : 0} route={'acs_alarm_filter/7/fatch'} color={`bg-purple text-white`} icon={`fa-regular fa-door-open`} class={`shadow-purple`} />
                            <HomeGrid title={`Lock Open`} value={alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.lock_open_status : 0} route={'acs_alarm_filter/2/fatch'} color={`bg-orange text-white`} icon={`fa-regular fa-lock-open`} class={`shadow-orange`} valueColor={'text-warning'} />
                            <HomeGrid title={`Security Breach`} value={alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.breach_status : 0} route={'acs_alarm_filter/6/fatch'} color={`bg-red text-white`} icon={`fa-regular fa-user-secret`} class={`shadow-danger  ${alarms?.site_alarm?.length > 0 ? alarms?.site_alarm[0]?.breach_status ? 'divAnimation' : `` : ``}`} />

                            {/* <HomeGrid title={`MDB Fault`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.mdb_fault : 0} route={'rms_alarm_filter/27/fatch'} color={`bg-pink text-white`} icon={`fa-regular fa-exclamation-triangle`} class={`shadow-purple`} valueColor={'text-danger'} /> */}
                            <HomeGrid title={`Human Alert`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.unknown_10 : 0} route={'rms_alarm_filter/23/fatch'} color={`bg-pink text-white`} icon={`fa-regular fa-exclamation-triangle`} class={`shadow-purple`} valueColor={'text-danger'} />
                            <HomeGrid title={`PG Running`} value={alarms?.rms_alarm_count?.length > 0 ? alarms?.rms_alarm_count[0]?.pg_status : 0} route={'rms_alarm_filter/9/fatch'} color={`bg-danger text-white`} icon={`fa-solid fa-microchip`} class={`shadow-purple`} valueColor={'text-danger'} />

                        </div>
                        <div className="row g-2 alarms-container-wrapper-home">
                            <div className="col-md-4">

                                <div className="card">
                                    <div className="card-body p-1 m-1">
                                        {/* need 2 graph here pie chart & bar chart, pie chart for tenant mains fail, and bar chart for DC Low & site down, 2bar */}
                                        <div className="row">
                                            <div className="col-md-4">
                                                <ReactEcharts ref={echarts_react_2} style={{ height: "200px" }} option={option} />
                                            </div>
                                            <div className="col-md-8">
                                                {/* // bar chart for dc low and site down */}
                                                <ReactEcharts ref={echarts_react_3} style={{ height: "200px" }} option={option_bar} />
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div className="card">
                                    <div className="card-body">
                                        <table className="table ">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Tenant</th>
                                                    <th scope="col">Anchor</th>
                                                    <th scope="col">Colo</th>
                                                    <th scope="col">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 && select_tenant_alarm_count?.data?.map((tenant, i) => (
                                                    <tr key={i}>
                                                        <td><img src={`${tenant.node == 'BL-001' ? '/img/bl.svg' : (tenant.node == 'RB-001' ? '/img/robi.png' : (tenant.node == 'GP-001' ? '/img/grameenphone.png' : ''))}`} style={{ height: '25px' }} /> <b></b>{tenant.name == 'Banglalink' ? '' : tenant.name}</td>
                                                        <td>{tenant.node == 'GP-001' ? (tenant.non_colo_sites+2) : tenant.non_colo_sites}</td>
                                                        <td>{tenant.node == 'GP-001' ? (tenant.colo_sites-2) : tenant.colo_sites}</td>
                                                        <td>{tenant.total_site}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th> <b>Total</b></th>
                                                    <th>{!select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 ? select_tenant_alarm_count?.data?.reduce((sum, tenant) => sum + (tenant.node == 'GP-001' ? (tenant.non_colo_sites+2) : tenant.non_colo_sites), 0) : 0}</th>
                                                    <th>{!select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 ? select_tenant_alarm_count?.data?.reduce((sum, tenant) => sum + (tenant.node == 'GP-001' ? (tenant.colo_sites-2) : tenant.colo_sites), 0) : 0}</th>
                                                    <th>{!select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 ? select_tenant_alarm_count?.data?.reduce((sum, tenant) => sum + tenant.total_site, 0) : 0}</th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>
                                </div>


                            </div>
                            <div className="col-md-8">
                                <div className="card mb-2">
                                    <div className="card-header bg-white border-bottom">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <ul className="nav nav-pills custom-nav-pills" id="pills-tab" role="tablist">
                                                <li className="nav-item me-2" role="presentation">
                                                    <button onClick={() => setTabActive('alarm')} className="nav-link nav-link-custom active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true"><i className="fa-regular fa-bell me-2"></i>Alarms</button>
                                                </li>

                                                <li className="nav-item me-2" role="presentation">
                                                    <button onClick={() => setTabActive('rectifier')} className="nav-link nav-link-custom" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false"><i className="fa-solid fa-microchip me-2"></i>Rectifier</button>
                                                </li>

                                                  <li className="nav-item me-2" role="presentation">
                                                    <button onClick={() => setTabActive('load')} className="nav-link nav-link-custom" id="pills-load-tab" data-bs-toggle="pill" data-bs-target="#pills-load" type="button" role="tab" aria-controls="pills-load" aria-selected="false"><i className="fa-solid fa-line-chart me-2"></i>Load Status</button>
                                                </li>
                                                <li className="nav-item me-2" role="presentation">
                                                    <button onClick={() => setTabActive('availability')} className="nav-link nav-link-custom" id="pills-availability-tab" data-bs-toggle="pill" data-bs-target="#pills-availability" type="button" role="tab" aria-controls="pills-availability" aria-selected="false"><i className="fa-solid fa-signal me-2"></i>Availability</button>
                                                </li>
                                            </ul>
                                            <div >
                                                <div className={`input-group ${tabActive === 'alarm' ? '' : 'd-none'}`}>
                                                    <div className="btn-group" role="group" aria-label="Value Percent Toggle" id="value_and_percent">
                                                        <input type="radio" defaultChecked className="btn-check" name="dataType" id="valueBtn" autoComplete="off" onChange={() => setSwitchValuePercent('value')} />
                                                        <label className="btn btn-outline-success" htmlFor="valueBtn">VAL</label>

                                                        <input type="radio" className="btn-check" name="dataType" id="percentBtn" autoComplete="off" onChange={() => setSwitchValuePercent('percent')} />
                                                        <label className="btn btn-outline-success" htmlFor="percentBtn">%</label>
                                                    </div>
                                                    <select className="form-select form-select-sm ms-2 d-none" aria-label="Select Time Range">
                                                        <option selected>Select Tenant</option>
                                                    </select>

                                                    <div style={{ minWidth: 180 }} className="ms-2">
                                                        <Select
                                                            isClearable
                                                            placeholder="Select Cluster"
                                                            options={clusterOptions}
                                                            value={selectedCluster}
                                                            onChange={(opt) => setSelectedCluster(opt)}
                                                            
                                                            classNamePrefix="rs"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                control: (base) => ({ ...base, minHeight: 30, height: 30 }),
                                                                valueContainer: (base) => ({ ...base, padding: '0 6px' }),
                                                                indicatorsContainer: (base) => ({ ...base, height: 30 }),
                                                            }}
                                                        />
                                                    </div>

                                                    {/* //export drowpdownmenu */}
                                                    <button className="btn btn-sm btn-outline-secondary ms-2 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        {loading_export ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <i className="fa-solid fa-file-export"> Export</i>}
                                                    </button>
                                                    <ul className="dropdown-menu dropdown-menu-end">
                                                        <li><button className="dropdown-item" onClick={exportAlarm}> RMS Events</button></li>
                                                        <li><button className="dropdown-item" onClick={exportAcsAlarm}> ACS Events</button></li>
                                                        <li><button className="dropdown-item" onClick={exportRectifierAlarm}> Rectifier Events</button></li>
                                                    </ul>
                                                    

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="card-body p-1 m-1">

                                        <div className="tab-content p-0 m-0" id="pills-tabContent">
                                            <div className="tab-pane fade show active p-0 m-0" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                                <div className="row g-3">
                                                    <div className="col-md-6 ">
                                                        <div className="row p-2">
                                                            <div className="col-md-6 mb-2 card rounded-1 shadow-sm">
                                                                <div>
                                                                    <img src={`/img/cof.jpeg`} style={{ height: '28px' }} />
                                                                </div>
                                                                <table className="table table-borderless rms-all-nav m-0 table-fixed w-100">
                                                                    <tbody>

                                                                        <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.mains_fail > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/1/fatch`} title={`Mains Fail`} alarm={
                                                                            alarms?.rms_alarm_count?.length > 0
                                                                                ? switch_value_percent === 'value'
                                                                                    ? Math.round(alarms?.rms_alarm_count[0]?.mains_fail ?? 0)
                                                                                    : Number(
                                                                                        (
                                                                                            (Number(alarms?.rms_alarm_count[0]?.mains_fail ?? 0) /
                                                                                                Number(
                                                                                                    select_tenant_alarm_count?.data?.length > 0
                                                                                                        ? select_tenant_alarm_count.data.reduce(
                                                                                                            (sum, tenant) => sum + tenant.total_site,
                                                                                                            0
                                                                                                        )
                                                                                                        : 1
                                                                                                )) *
                                                                                            100
                                                                                        ).toFixed(0)   // 👈 2 decimal
                                                                                    ) + '%'
                                                                                : 0
                                                                        }
                                                                        />
                                                                        <RectifierAlarmTd className={`text-center  ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.dc_low > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/2/fatch`} title={`DC Low`} alarm={
                                                                            alarms?.rms_alarm_count?.length > 0
                                                                                ? switch_value_percent === 'value'
                                                                                    ? Math.round(alarms?.rms_alarm_count[0]?.dc_low ?? 0)
                                                                                    : Number(
                                                                                        (
                                                                                            (Number(alarms?.rms_alarm_count[0]?.dc_low ?? 0) /
                                                                                                Number(
                                                                                                    select_tenant_alarm_count?.data?.length > 0
                                                                                                        ? select_tenant_alarm_count.data.reduce(
                                                                                                            (sum, tenant) => sum + tenant.total_site,
                                                                                                            0
                                                                                                        )
                                                                                                        : 1
                                                                                                )) *
                                                                                            100
                                                                                        ).toFixed(0)   // 👈 2 decimal
                                                                                    ) + '%'
                                                                                : 0
                                                                        } />
                                                                        <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.load_disconnect > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`site_down_history/fetch`} title={`Site Down`} alarm={
                                                                            alarms?.rms_alarm_count?.length > 0
                                                                                ? switch_value_percent === 'value'
                                                                                    ? Math.round(alarms?.rms_alarm_count[0]?.load_disconnect ?? 0)
                                                                                    : Number(
                                                                                        (
                                                                                            (Number(alarms?.rms_alarm_count[0]?.load_disconnect ?? 0) /
                                                                                                Number(
                                                                                                    select_tenant_alarm_count?.data?.length > 0
                                                                                                        ? select_tenant_alarm_count.data.reduce(
                                                                                                            (sum, tenant) => sum + tenant.total_site,
                                                                                                            0
                                                                                                        )
                                                                                                        : 1
                                                                                                )) *
                                                                                            100
                                                                                        ).toFixed(0)   // 👈 2 decimal
                                                                                    ) + '%'
                                                                                : 0
                                                                        } />
                                                                        <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.mdb_fault > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/27/fatch`} title={`MDB Fault`} alarm={
                                                                            alarms?.rms_alarm_count?.length > 0
                                                                                ? switch_value_percent === 'value'
                                                                                    ? Math.round(alarms?.rms_alarm_count[0]?.mdb_fault ?? 0)
                                                                                    : Number(
                                                                                        (
                                                                                            (Number(alarms?.rms_alarm_count[0]?.mdb_fault ?? 0) /
                                                                                                Number(
                                                                                                    select_tenant_alarm_count?.data?.length > 0
                                                                                                        ? select_tenant_alarm_count.data.reduce(
                                                                                                            (sum, tenant) => sum + tenant.total_site,
                                                                                                            0
                                                                                                        )
                                                                                                        : 1
                                                                                                )) *
                                                                                            100
                                                                                        ).toFixed(0)   // 👈 2 decimal
                                                                                    ) + '%'
                                                                                : 0
                                                                        } />

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            {!select_tenant_alarm_count?.loading && select_tenant_alarm_count?.data?.length > 0 && select_tenant_alarm_count?.data?.map((tenant, i) => (
                                                                <div className="col-md-6 mb-2 card rounded-1 shadow-sm" key={i}>
                                                                    <div>
                                                                        <img src={`${tenant.node == 'BL-001' ? '/img/bl.svg' : (tenant.node == 'RB-001' ? '/img/robi.png' : (tenant.node == 'GP-001' ? '/img/grameenphone.png' : ''))}`} style={{ height: '25px' }} /> <b>{tenant.node == 'BL-001' ? '' : tenant.name}</b>

                                                                    </div>
                                                                    <table className="table table-borderless rms-all-nav m-0 table-fixed w-100">
                                                                        <tbody>
                                                                            <>
                                                                                <RectifierAlarmTd className={`text-center ${tenant.mains_fail > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/1/fatch?tenant_id=${tenant.id}`} title={`Mains Fail`} alarm={switch_value_percent == 'value' ? tenant.mains_fail : `${tenant.mains_fail_percent}%`} key={`rm-${i}`} />
                                                                                <RectifierAlarmTd className={`text-center  ${tenant.dc_low > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/2/fatch?tenant_id=${tenant.id}`} title={`DC Low`} alarm={switch_value_percent == 'value' ? tenant.dc_low : `${tenant.dc_low_percent}%`} key={`dc-${i}`} />
                                                                                <RectifierAlarmTd className={`text-center ${tenant.site_down > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`site_down_history/fetch?tenant_id=${tenant.id}`} title={`Site Down`} alarm={switch_value_percent == 'value' ? tenant.site_down : `${tenant.site_down_percent}%`} key={`sd-${i}`} />
                                                                                <RectifierAlarmTd className={`text-center ${tenant.mdb_fault > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/27/fatch?tenant_id=${tenant.id}`} title={`MDB Fault`} alarm={switch_value_percent == 'value' ? tenant.mdb_fault : `${tenant.mdb_fault_percent}%`} key={`mdb-${i}`} />

                                                                            </>
                                                                        </tbody>
                                                                    </table>


                                                                </div>
                                                            ))}

                                                        </div>

                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="row p-2">
                                                            <div className="col-md-6 mb-2 card rounded-1 shadow-sm">
                                                                <div>
                                                                    <b>ACS Alarm</b>
                                                                </div>
                                                                <div>
                                                                    <table className="table table-borderless rms-all-nav m-0 table-fixed w-100">
                                                                        <tbody>
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.site_alarm?.length > 0 && alarms?.site_alarm[0]?.door_status > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`acs_alarm_filter/7/fatch`} title={`Door Open`} alarm={
                                                                                alarms?.site_alarm?.length > 0 ?
                                                                                    switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.site_alarm[0]?.door_status ?? 0)
                                                                                        :
                                                                                        Number((alarms?.site_alarm[0]?.door_status / alarms?.total_sites) * 100).toFixed(0) + '%'
                                                                                    : 0
                                                                            } key={'lc-1'} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.site_alarm?.length > 0 && alarms?.site_alarm[0]?.lock_open_status > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`acs_alarm_filter/2/fatch`} title={`Lock Open`} alarm={
                                                                                alarms?.site_alarm?.length > 0 ?
                                                                                    switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.site_alarm[0]?.lock_open_status ?? 0)
                                                                                        :
                                                                                        Number((alarms?.site_alarm[0]?.lock_open_status / alarms?.total_sites) * 100).toFixed(0) + '%'
                                                                                    : 0
                                                                            } key={'lc-2'} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.site_alarm?.length > 0 && alarms?.site_alarm[0]?.vib_sens_status > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`acs_alarm_filter/1/fatch`} title={`Vibration`} alarm={
                                                                                alarms?.site_alarm?.length > 0 ?
                                                                                    switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.site_alarm[0]?.vib_sens_status ?? 0)
                                                                                        :
                                                                                        Number((alarms?.site_alarm[0]?.vib_sens_status / alarms?.total_sites) * 100).toFixed(0) + '%'
                                                                                    : 0
                                                                            } key={'lc-3'} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.site_alarm?.length > 0 && alarms?.site_alarm[0]?.lock_fault > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`acs_alarm_filter/4/fatch`} title={`Lock Fault`} alarm={
                                                                                alarms?.site_alarm?.length > 0 ?
                                                                                    switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.site_alarm[0]?.lock_fault ?? 0)
                                                                                        :
                                                                                        Number((alarms?.site_alarm[0]?.lock_fault / alarms?.total_sites) * 100).toFixed(0) + '%'
                                                                                    : 0
                                                                            } key={'lc-4'} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.site_alarm?.length > 0 && alarms?.site_alarm[0]?.lock_close_fail > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`acs_alarm_filter/10/fatch`} title={`Lock Close Failed`} alarm={
                                                                                alarms?.site_alarm?.length > 0 ?
                                                                                    switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.site_alarm[0]?.lock_close_fail ?? 0)
                                                                                        :
                                                                                        Number((alarms?.site_alarm[0]?.lock_close_fail / alarms?.total_sites) * 100).toFixed(0) + '%'
                                                                                    : 0
                                                                            } key={'lc-5'} />

                                                                            <RectifierAlarmTd className={`text-center ${alarms?.site_alarm?.length > 0 && alarms?.site_alarm[0]?.card_reader_fault > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`acs_alarm_filter/3/fatch`} title={`Card Reader Fault`} alarm={
                                                                                alarms?.site_alarm?.length > 0 ?
                                                                                    switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.site_alarm[0]?.card_reader_fault ?? 0)
                                                                                        :
                                                                                        Number((alarms?.site_alarm[0]?.card_reader_fault / alarms?.total_sites) * 100).toFixed(0) + '%'
                                                                                    : 0

                                                                            } key={'lc-6'} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.site_alarm?.length > 0 && alarms?.site_alarm[0]?.card_temper_status > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`acs_alarm_filter/9/fatch`} title={`Card Temper Alert`} alarm={
                                                                                alarms?.site_alarm?.length > 0 ?
                                                                                    switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.site_alarm[0]?.card_temper_status ?? 0)
                                                                                        :
                                                                                        Number((alarms?.site_alarm[0]?.card_temper_status / alarms?.total_sites) * 100).toFixed(0) + '%'
                                                                                    : 0
                                                                            } key={'lc-7'} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.site_alarm?.length > 0 && alarms?.site_alarm[0]?.door_open_timeout > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`acs_alarm_filter/11/fatch`} title={`Door Open Timeout`} alarm={
                                                                                alarms?.site_alarm?.length > 0 ?
                                                                                    switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.site_alarm[0]?.door_open_timeout ?? 0)
                                                                                        :
                                                                                        Number((alarms?.site_alarm[0]?.door_open_timeout / alarms?.total_sites) * 100).toFixed(0) + '%'
                                                                                    : 0
                                                                            } key={'lc-8'} />
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 mb-2 card rounded-1 shadow-sm">
                                                                <div>
                                                                    <b>Other's RMS Alarm</b>
                                                                </div>
                                                                <div>
                                                                    <table className="table table-borderless rms-all-nav m-0 table-fixed w-100">
                                                                        <tbody>

                                                                            <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.phase_missing > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/28/fatch`} title={`Phase Fault`} alarm={
                                                                                alarms?.rms_alarm_count?.length > 0
                                                                                    ? switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.rms_alarm_count[0]?.phase_missing ?? 0)
                                                                                        : Number(
                                                                                            (
                                                                                                (Number(alarms?.rms_alarm_count[0]?.phase_missing ?? 0) /
                                                                                                    Number(
                                                                                                        select_tenant_alarm_count?.data?.length > 0
                                                                                                            ? select_tenant_alarm_count.data.reduce(
                                                                                                                (sum, tenant) => sum + tenant.total_site,
                                                                                                                0
                                                                                                            )
                                                                                                            : 1
                                                                                                    )) *
                                                                                                100
                                                                                            ).toFixed(0)   // 👈 2 decimal
                                                                                        ) + '%'
                                                                                    : 0
                                                                            } key={112} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.smoke > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/6/fatch`} title={`Smoke`} alarm={
                                                                                alarms?.rms_alarm_count?.length > 0
                                                                                    ? switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.rms_alarm_count[0]?.smoke ?? 0)
                                                                                        : Number(
                                                                                            (
                                                                                                (Number(alarms?.rms_alarm_count[0]?.smoke ?? 0) /
                                                                                                    Number(
                                                                                                        select_tenant_alarm_count?.data?.length > 0
                                                                                                            ? select_tenant_alarm_count.data.reduce(
                                                                                                                (sum, tenant) => sum + tenant.total_site,
                                                                                                                0
                                                                                                            )
                                                                                                            : 1
                                                                                                    )) *
                                                                                                100
                                                                                            ).toFixed(0)   // 👈 2 decimal
                                                                                        ) + '%'
                                                                                    : 0
                                                                            } key={113} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.dc_fan_fault > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/7/fatch`} title={`DC Fan Fault`} alarm={
                                                                                alarms?.rms_alarm_count?.length > 0
                                                                                    ? switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.rms_alarm_count[0]?.dc_fan_fault ?? 0)
                                                                                        : Number(
                                                                                            (
                                                                                                (Number(alarms?.rms_alarm_count[0]?.dc_fan_fault ?? 0) /
                                                                                                    Number(
                                                                                                        select_tenant_alarm_count?.data?.length > 0
                                                                                                            ? select_tenant_alarm_count.data.reduce(
                                                                                                                (sum, tenant) => sum + tenant.total_site,
                                                                                                                0
                                                                                                            )
                                                                                                            : 1
                                                                                                    )) *
                                                                                                100
                                                                                            ).toFixed(0)   // 👈 2 decimal
                                                                                        ) + '%'
                                                                                    : 0
                                                                            } key={114} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.aviation_light_fault > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/8/fatch`} title={`Aviation Light`} alarm={
                                                                                alarms?.rms_alarm_count?.length > 0
                                                                                    ? switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.rms_alarm_count[0]?.aviation_light_fault ?? 0)
                                                                                        : Number(
                                                                                            (
                                                                                                (Number(alarms?.rms_alarm_count[0]?.aviation_light_fault ?? 0) /
                                                                                                    Number(
                                                                                                        select_tenant_alarm_count?.data?.length > 0
                                                                                                            ? select_tenant_alarm_count.data.reduce(
                                                                                                                (sum, tenant) => sum + tenant.total_site,
                                                                                                                0
                                                                                                            )
                                                                                                            : 1
                                                                                                    )) *
                                                                                                100
                                                                                            ).toFixed(0)   // 👈 2 decimal
                                                                                        ) + '%'
                                                                                    : 0
                                                                            } key={120} />

                                                                            <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.water_leakage > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/5/fatch`} title={`Water Leakage`} alarm={
                                                                                alarms?.rms_alarm_count?.length > 0
                                                                                    ? switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.rms_alarm_count[0]?.water_leakage ?? 0)
                                                                                        : Number(
                                                                                            (
                                                                                                (Number(alarms?.rms_alarm_count[0]?.water_leakage ?? 0) /
                                                                                                    Number(
                                                                                                        select_tenant_alarm_count?.data?.length > 0
                                                                                                            ? select_tenant_alarm_count.data.reduce(
                                                                                                                (sum, tenant) => sum + tenant.total_site,
                                                                                                                0
                                                                                                            )
                                                                                                            : 1
                                                                                                    )) *
                                                                                                100
                                                                                            ).toFixed(0)   // 👈 2 decimal
                                                                                        ) + '%'
                                                                                    : 0
                                                                            } key={116} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.rectifier_fault > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/3/fatch`} title={`Module Fault`} alarm={
                                                                                alarms?.rms_alarm_count?.length > 0
                                                                                    ? switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.rms_alarm_count[0]?.rectifier_fault ?? 0)
                                                                                        : Number(
                                                                                            (
                                                                                                (Number(alarms?.rms_alarm_count[0]?.rectifier_fault ?? 0) /
                                                                                                    Number(
                                                                                                        select_tenant_alarm_count?.data?.length > 0
                                                                                                            ? select_tenant_alarm_count.data.reduce(
                                                                                                                (sum, tenant) => sum + tenant.total_site,
                                                                                                                0
                                                                                                            )
                                                                                                            : 1
                                                                                                    )) *
                                                                                                100
                                                                                            ).toFixed(0)   // 👈 2 decimal
                                                                                        ) + '%'
                                                                                    : 0
                                                                            } key={115} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.temp_high > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/15/fatch`} title={`Odc Temp High`} alarm={
                                                                                alarms?.rms_alarm_count?.length > 0
                                                                                    ? switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.rms_alarm_count[0]?.temp_high ?? 0)
                                                                                        : Number(
                                                                                            (
                                                                                                (Number(alarms?.rms_alarm_count[0]?.temp_high ?? 0) /
                                                                                                    Number(
                                                                                                        select_tenant_alarm_count?.data?.length > 0
                                                                                                            ? select_tenant_alarm_count.data.reduce(
                                                                                                                (sum, tenant) => sum + tenant.total_site,
                                                                                                                0
                                                                                                            )
                                                                                                            : 1
                                                                                                    )) *
                                                                                                100
                                                                                            ).toFixed(0)   // 👈 2 decimal
                                                                                        ) + '%'
                                                                                    : 0
                                                                            } key={117} />
                                                                            <RectifierAlarmTd className={`text-center ${alarms?.rms_alarm_count?.length > 0 && alarms?.rms_alarm_count[0]?.llvd > 0 ? 'badge-custom-danger' : 'badge-success'} fw-bold`} link={`rms_alarm_filter/16/fatch`} title={`LLVD (Non-Critical)`} alarm={
                                                                                alarms?.rms_alarm_count?.length > 0
                                                                                    ? switch_value_percent === 'value'
                                                                                        ? Math.round(alarms?.rms_alarm_count[0]?.llvd ?? 0)
                                                                                        : Number(
                                                                                            (
                                                                                                (Number(alarms?.rms_alarm_count[0]?.llvd ?? 0) /
                                                                                                    Number(
                                                                                                        select_tenant_alarm_count?.data?.length > 0
                                                                                                            ? select_tenant_alarm_count.data.reduce(
                                                                                                                (sum, tenant) => sum + tenant.total_site,
                                                                                                                0
                                                                                                            )
                                                                                                            : 1
                                                                                                    )) *
                                                                                                100
                                                                                            ).toFixed(0)   // 👈 2 decimal
                                                                                        ) + '%'
                                                                                    : 0
                                                                            } key={118} />

                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                                                <RectifierCard />
                                            </div>
                                            <div className="tab-pane fade" id="pills-load" role="tabpanel" aria-labelledby="pills-load-tab">
                                               <LoadStatus />
                                                </div>
                                                <div className="tab-pane fade" id="pills-availability" role="tabpanel" aria-labelledby="pills-availability-tab">
                                                    <Availability />
                                                    </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>

                    {/* // tab for functional dashboard */}
                    {/* <div className="tab-pane fade" id="pills-report" role="tabpanel" aria-labelledby="pills-report-tab">
                         <FunctionalHome />
                    </div> */}

                </div>
            </div>

        </>
    )
}